import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonSection() {
  const comparisons = [{
    without: 'Llamar a alguien por cada cosa',
    with: 'Lo resolvés vos'
  }, {
    without: 'Gastar plata en arreglos',
    with: 'Ahorrás dinero'
  }, {
    without: 'Miedo a la electricidad',
    with: 'Sabés qué hacer'
  }, {
    without: 'Dependencia',
    with: 'Independencia'
  }, {
    without: 'No saber por dónde empezar',
    with: 'Paso a paso'
  }, {
    without: 'Problemas sin resolver',
    with: 'Casa funcionando'
  }];
  return <section className="py-0 bg-white px-4" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4 text-gray-900" data-id="element-38">
            🔄 SIN ESTE MEGA PACK / CON ESTE MEGA PACK
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl overflow-hidden border border-gray-200 shadow-xl shadow-gray-200/50" data-id="element-39">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-40">
            <div className="p-6 text-center border-r border-gray-200" data-id="element-41">
              <h3 className="text-xl font-heading font-bold text-gray-500" data-id="element-42">
                Sin el Mega Pack
              </h3>
            </div>
            <div className="p-6 text-center bg-brand-50" data-id="element-43">
              <h3 className="text-xl font-heading font-bold text-brand-600" data-id="element-44">
                Con el Mega Pack
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-45">
            {comparisons.map((row, index) => <motion.div key={index} className="grid grid-cols-2 hover:bg-gray-50/50 transition-colors" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} data-id="element-46">
                <div className="p-4 md:p-6 flex items-center gap-3 border-r border-gray-100" data-id="element-47">
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0 border border-red-100" data-id="element-48">
                    <X className="w-4 h-4 text-red-500" data-id="element-49" />
                  </div>
                  <span className="text-gray-500 text-sm md:text-base font-medium" data-id="element-50">
                    {row.without}
                  </span>
                </div>
                <div className="p-4 md:p-6 flex items-center gap-3 bg-brand-50/30" data-id="element-51">
                  <div className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center flex-shrink-0 border border-brand-200" data-id="element-52">
                    <Check className="w-4 h-4 text-brand-600" data-id="element-53" />
                  </div>
                  <span className="text-gray-900 font-semibold text-sm md:text-base" data-id="element-54">
                    {row.with}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}